<template>
  <main class="description" :class="{ reverse: direction === 'right'}">
    <Description
      :title="title"
      :content="content"
      :showbtn="showbtn"
      @detail="handleClick"
    />
    <div class="description-img">
      <img v-if="type === 'bg'" src="@/assets/img/standard/standard-bg.png" alt="">
      <img v-if="type === 'objective'" src="@/assets/img/standard/standard-objective.png" alt="">
      <img v-if="type === 'range'" src="@/assets/img/standard/standard-range.png" alt="">
    </div>
  </main>
</template>

<script lang="ts" setup>
import Description from './description-text.vue'
import { DescriptionProps } from './description.ts'



withDefaults(defineProps<DescriptionProps>(), {
  type: 'bg',
  direction: 'left'
})

const emit = defineEmits<{
  (e: 'detail'): void
}>()
const handleClick = () => {
  emit('detail')
}
</script>

<style lang="scss" scoped>
.description {
  width: 1200px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-direction: row;
  margin: 72px auto 0;
  &.reverse {
    flex-direction: row-reverse;
  }
  .description-img {
    width: 592px;
    img {
      width: 100%;
    }
  }
}
</style>
